<template>
  <b-modal
    ref="modal"
    title="Classificação"
    size="md"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok="onSaveClicked($event)"
  >
    <b-form>
      <b-row>
        <b-col v-if="companyClassification.receivingMeans" cols="6">
          <b-form-group label="Meio de Recebimento">
            <b-form-select
              v-model="classification.receivingMeans"
              class="form-control"
              :options="classificationOptions.receivingMeans"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.origin" cols="6">
          <b-form-group label="Origem da Comunicação">
            <b-form-select
              v-model="classification.origin"
              class="form-control"
              :options="classificationOptions.origin"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.reportingAgent" cols="6">
          <b-form-group label="Agente Denunciante">
            <b-form-select
              v-model="classification.reportingAgent"
              class="form-control"
              :options="classificationOptions.reportingAgent"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.level" cols="6">
          <b-form-group label="Classificação/Classe Interna">
            <b-form-select
              v-model="classification.level"
              class="form-control"
              :options="classificationOptions.level"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.nature" cols="6">
          <b-form-group label="Natureza">
            <b-form-select
              v-model="classification.nature"
              class="form-control"
              :options="classificationOptions.nature"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.responsibleDepartment" cols="6">
          <b-form-group label="Área responsável pelo tratamento">
            <b-form-select
              v-model="classification.responsibleDepartment"
              class="form-control"
              :options="classificationOptions.responsibleDepartment"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.involvedDepartment" cols="6">
          <b-form-group label="Setor da Ocorrência">
            <b-form-select
              v-model="classification.involvedDepartment"
              class="form-control"
              :options="classificationOptions.involvedDepartment"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.businessGroup" cols="6">
          <b-form-group label="Empresa do Grupo">
            <b-form-select
              v-model="classification.businessGroup"
              class="form-control"
              :options="classificationOptions.businessGroup"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.businessUnit" cols="6">
          <b-form-group label="Unidade/Posto/Filial">
            <b-form-select
              v-model="classification.businessUnit"
              class="form-control"
              :options="classificationOptions.businessUnit"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.dsarRequirementType" cols="6">
          <b-form-group label="Tipo de Requisição">
            <b-form-select
              v-model="classification.dsarRequirementType"
              class="form-control"
              :options="classificationOptions.dsarRequirementType"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.ombudsmanNature" cols="6">
          <b-form-group label="Natureza da Comunicação">
            <b-form-select
              v-model="classification.ombudsmanNature"
              class="form-control"
              :options="classificationOptions.ombudsmanNature"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.ombudsmanService" cols="6">
          <b-form-group label="Serviço reclamado">
            <b-form-select
              v-model="classification.ombudsmanService"
              class="form-control"
              :options="classificationOptions.ombudsmanService"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.ombudsmanSegment" cols="6">
          <b-form-group label="Segmento do cliente">
            <b-form-select
              v-model="classification.ombudsmanSegment"
              class="form-control"
              :options="classificationOptions.ombudsmanSegment"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="companyClassification.relatedProject" cols="6">
          <b-form-group label="Contrato/Projeto">
            <b-form-select
              v-model="classification.relatedProject"
              class="form-control"
              :options="classificationOptions.relatedProject"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-for="group in classificationGroups" :key="group._id" cols="6">
          <b-form-group :label="group.name">
            <b-form-select
              v-model="classification[`custom_${group._id}`]"
              class="form-control"
              :options="
                group.options.map((option) => ({
                  text: option.value,
                  value: option._id,
                }))
              "
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { classifyComplaint } from "@/api/complaint";
import { classifyDSAR } from "@/api/dsar";
import { classifyOmbudsman } from "@/api/ombudsman";
import { mapGetters } from "vuex";
import { getActiveCompanyClassificationGroupsOptions } from "../../api/company";

export default {
  name: "ClassificationModal",
  props: {
    complaint: {
      type: Object,
      default: null,
    },
    dsar: {
      type: Object,
      default: null,
    },
    ombudsman: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      classification: {},
      companyClassification: {},
      classificationGroups: [],
    };
  },
  computed: {
    ...mapGetters(["classificationOptions"]),
    type() {
      if (this.ombudsman) {
        return "ombudsman";
      }
      if (this.dsar) {
        return "dsar";
      }
      return "complaint";
    },
    holder() {
      switch (this.type) {
        case "ombudsman":
          return this.ombudsman;
        case "dsar":
          return this.dsar;
        case "complaint":
          return this.complaint;
      }
      return null;
    },
    action() {
      switch (this.type) {
        case "ombudsman":
          return classifyOmbudsman;
        case "dsar":
          return classifyDSAR;
        case "complaint":
          return classifyComplaint;
      }
      return null;
    },
    options() {
      const opts = ["receivingMeans"];
      if (this.type === "ombudsman") {
        opts.push(
          "involvedDepartment",
          "businessUnit",
          "ombudsmanNature",
          "ombudsmanClosure",
          "ombudsmanService",
          "ombudsmanSegment"
        );
      } else if (this.type === "dsar") {
        opts.push("dsarClosure", "dsarRequirementType");
      } else {
        opts.push(
          "origin",
          "reportingAgent",
          "level",
          "nature",
          "responsibleDepartment",
          "involvedDepartment",
          "businessUnit",
          "businessGroup",
          "complaintClosure",
          "relatedProject"
        );
      }

      for (const group of this.classificationGroups) {
        opts.push(`custom_${group._id}`);
      }

      return opts;
    },
  },
  async created() {
    const groups = await getActiveCompanyClassificationGroupsOptions(
      this.holder.company._id,
      this.type
    );
    this.classificationGroups = groups.data;
    this.classification = this.options.reduce((current, item) => {
      current[item] =
        (this.holder.classification && this.holder.classification[item]) ||
        null;
      return current;
    }, {});
    this.companyClassification = this.options.reduce((current, item) => {
      if (item.startsWith("custom_")) {
        const group =
          this.classificationGroups.find(
            (group) => group._id === parseInt(item.replace("custom_", ""))
          ) || null;
        current[item] = group.enabled;
      } else if (
        this.holder.company.classification[item].enabled !== undefined
      ) {
        current[item] = this.holder.company.classification[item].enabled;
      } else {
        current[item] = true;
      }
      return current;
    }, {});
  },
  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    async onSaveClicked(bvEvt) {
      bvEvt.preventDefault();
      const validated = await this.$validator.validateAll();

      if (!validated) {
        return;
      }

      try {
        await this.action(this.holder._id, this.classification);
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      this.$bvToast.toast("Classificação editada com sucesso!", {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
      this.$emit("classification-changed", this.classification);

      this.$refs.modal.hide();
    },

    show() {
      this.$refs.modal.show();
    },
  },
};
</script>
